// src/components/Dashboard/RoleDashboard/roleConfig.js

// Central place for per-role differences (titles, prices, limits, permissions).
// If you prefer to keep this inline, you can move these values directly into
// RoleDashboard.js — this file just keeps things tidy.

const ROLE_CONFIG = {
    agent: {
        title: "Agent Dashboard",
        pricing: { playerPurchaseUSD: 100 },
        limits: { dailyPurchases: 10 },
        permissions: { canPurchase: true },
    },
    scout: {
        title: "Scout Dashboard",
        pricing: { playerPurchaseUSD: 50 },
        limits: { dailyPurchases: 5 },
        permissions: { canPurchase: true },
    },
    club: {
        title: "Club Dashboard",
        pricing: { playerPurchaseUSD: 150 },
        limits: { dailyPurchases: 20 },
        permissions: { canPurchase: true },
    },
};

export default ROLE_CONFIG;
